const ARTICLES = new Set(['the', 'a', 'an']);

/**
 * First word of a shop name worth addressing the retailer by — skips leading
 * articles and any token that doesn't start with a letter (numbers, separators
 * like the "03 ·" prefix on QA fixtures), so "The Mallets" → "Mallets" and
 * "Pages Bookshop" → "Pages".
 */
export function firstMeaningfulWord(name) {
	if (!name) return '';
	for (const word of String(name).trim().split(/\s+/)) {
		const cleaned = word.replace(/^[^\p{L}]+|[^\p{L}\p{N}]+$/gu, '');
		if (cleaned && !ARTICLES.has(cleaned.toLowerCase())) return cleaned;
	}
	return '';
}
